<template>
    <div class="p-3">
        <loader v-if="pageLoader"></loader>
        <div class="row mb-4" v-if="parseInt(get_user.step) < 3">
            <div class="col-12 col-lg-9">
                <div class="bg-white flexMob d-flex align-items-center justify-content-between border-radius-5 p-3">
                    <div class="pie-wrapper d-flex align-items-center progress-45 style-2">
                        <vue-circle
                            :progress="(userCstep == 0) ? 1 :userCstep*33"
                            :size="60"
                            :reverse="false"
                            line-cap="round"
                            :fill="fill"
                            empty-fill="rgba(0, 0, 0, .1)"
                            :animation-start-value="0.0"
                            :start-angle="4.7"
                            insert-mode="append"
                            :thickness="3"
                            :show-percent="true"
                            ref="completeCircle"
                        >
                        </vue-circle>
                        <div class="pieText ml-3"><p> You are just few steps away</p> <h3> Activate Your Gini Account Now!</h3></div>
                    </div>
                    <div class="barSusscess position-relative w-50">
                        <div class="progress mb-3">
                            <div class="progress-bar" :style="(parseInt(get_user.step) == 1)?'width:50%':(parseInt(get_user.step) > 1)?'width:100%':'width:0%'"></div>
                        </div>
                        <div class="d-flex align-items-center w-100 barDotArea justify-content-between">
                            <div class="checkCircle" :class="{'uncheck':(parseInt(get_user.step) < 1)}">
                                <feather size="12px" type="check" v-if="parseInt(get_user.step) >= 1"></feather>
                            </div>
                            <div class="checkCircle" :class="{'uncheck':(parseInt(get_user.step) < 2)}">
                                <feather size="12px" type="check" v-if="parseInt(get_user.step) >= 2"></feather>
                            </div>
                            <div class="checkCircle" :class="{'uncheck':(parseInt(get_user.step) < 3)}">
                                <feather size="12px" type="check" v-if="parseInt(get_user.step) >= 3"></feather>
                            </div>
                        </div>
                        <div class="d-flex align-items-center justify-content-between inforMation mt-1">
                            <p class="mb-0">Membership Form</p>
                            <p class="mb-0 text-center">Payment Mode</p>
                            <p class="mb-0 text-right">On-Board Call</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-3">
                <div class="rgtRegistration d-flex align-items-center justify-content-between bg-white p-3 border-radius-5 mb-0">
                    <img src="../../../../static/website/images/stamped.svg" alt="Icon">
                    <router-link :to="stepPageOpenFunc(get_user.step)" class="btn btn-link btn-blue redBG">Complete Registration</router-link>
                </div>
            </div>
        </div>
        <div class="appoitmentsList">
            <div class="row ">
                <div class="col-12 col-md-9">
                    <div class="clientTop-Section mb-3 bg-white border-radius-5  d-flex align-items-center justify-content-between flex-wrap">
                      <div class="welcomeTitle p-5  col-12 col-md-6">
                            <h3>Welcome {{((get_user.profile.firstname ||'') + ' '+ (get_user.profile.lastname ||'')).trim()}}</h3>
                            <p>Let’s check your health with us Care with your health <br />from now to get more live better.</p>
                            <div class="buttonSection"><router-link to="/book-appointment" class="btn-blue d-flex align-items-center medium Button-new">Book Appointments</router-link></div>
                      </div>
                      <div class="welcomeImage col-12 col-md-6 d-flex justify-content-end"><img src="../../../../static/website/images/welcome-image.svg" class="WelcomeImage" alt="WelcomeImage"></div>  
                    </div>
                    <div class="row no-gutters mb-3 ">
                        <div class="col-12 col-md-6 pr-2 ">
                            <div class="card border-0">
                                <div class="leftOne bg-white border-radius-5 p-3 card-body  border-0">
                                    <div class="mainTitle mb-3  d-flex align-items-center justify-content-between ">
                                        <h4 class="mb-0">Upcoming Appointment</h4>
                                        <div class="seeAll">
                                            <router-link to="/book-appointment" class="themecolor d-flex align-items-center medium">See All
                                            </router-link>
                                        </div>
                                    </div>
                                    <div v-if="!pageLoader && appointmentList.totalRecords && appointmentList.totalRecords > 0">
                                        <div class="UpcomingAppointment"v-for="list,index in appointmentList.records" v-if="index < 1">
                                            <h2>Diabetes Program</h2>
                                            <p>Appointment Date: {{formatDate(list.appointment_date)}}<!-- 4 Feb 2022 --></p>
                                            <div class="d-flex">
                                                <p>{{list.start_time}} - {{list.end_time}}</p>
                                                <h4 class="d-flex align-items-center ml-4"><feather type="clock"></feather> Starts in {{startedIn(list)}}</h4>
                                            </div>
                                            <div class="d-flex doctor-info align-items-center border-top border-bottom py-3 my-3">
                                                <figure class="mb-0 mr-3"><img src="../../../../static/website/images/dr-image.svg" /></figure>
                                                <div>
                                                    <h3>{{list.doctorName || ''}}</h3>
                                                    <p>Specialist in Functional and Metabolic Medicine</p>
                                                </div>
                                            </div>
                                            <div class="buttonSection"><router-link to="" class="btn-blue d-flex align-items-center medium Button-new">Zoom Appointments</router-link></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 pl-2">
                            <div class="card border-0">
                                <div class="leftOne bg-white border-radius-5 p-3 card-body  border-0">
                                    <div class="mainTitle mb-3  d-flex align-items-center justify-content-between ">
                                        <h4 class="mb-0">Recommended Test </h4>
                                        <div class="seeAll">
                                            <router-link to="" class="themecolor d-flex align-items-center medium">See All </router-link>
                                        </div>
                                    </div>
                                    <div class="test-body">
                                        <!-- <div class="d-flex justify-content-between align-items-center testItem p-3 bg-white border-radius-5 border">
                                            <div>
                                                <div class="safeButton">
                                                    <a href="#" class="btn btn-yello-light"><i class="icon icon-shield"></i> Safe</a>
                                                </div>
                                                <h3>Comprehensive Full Body Checkup</h3>
                                                <p>Includes 91 Tests</p>
                                            </div>
                                            <div>
                                                <figure class="mb-0 gini-labs"><img src="../../../../static/website/images/gini-labs.svg" alt=""></figure>
                                            </div>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center testItem p-3 bg-white border-radius-5 border">
                                            <div>
                                                <div class="safeButton">
                                                    <a href="#" class="btn btn-yello-light"><i class="icon icon-shield"></i> Safe</a>
                                                </div>
                                                <h3>Comprehensive Full Body Checkup</h3>
                                                <p>Includes 91 Tests</p>
                                            </div>
                                            <div>
                                                <figure class="mb-0 gini-labs"><img src="../../../../static/website/images/gini-labs.svg" alt=""></figure>
                                            </div>
                                        </div> -->
                                        <div class="noData d-flex justify-content-center align-items-center py-5">
                                            <div class="w-100 text-center">
                                                <i class="icon icon-recommended-test"></i>
                                                <p>oops! You do not have an recommended test yet!</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row no-gutters">
                        <div class="col-12 bg-white border-radius-5 p-3">
                            <ul class="d-flex w-100 m-0 test-interaction nav border-bottom">
                                <li class="nav-item" @click="prescription = '1'"><a href="javascript:void(0)" class="nav-link" :class="[{'active': prescription == '1'}]">Current Prescription</a></li>
                                <li class="nav-item" @click="prescription = '2'"><a href="javascript:void(0)" class="nav-link" :class="[{'active': prescription == '2'}]">Past Prescription</a></li>
                            </ul>
                            <div class="content">
                                <!-- <div class="d-flex justify-content-between border-bottom align-items-center w-100 Current">
                                  <div class="Program d-flex align-items-center">
                                      <i class="icon icon-prescription"></i>
                                      <div class="Diebetes">
                                        <p>Program</p>
                                        <h3>Diebetes</h3>
                                      </div>
                                  </div>
                                  <div class="dr-history d-flex">
                                    <figure class="mb-0 mr-3"><img src="images/dr-image.svg" alt=""></figure>
                                    <div class="dr-history ">
                                      <h6>Name</h6>
                                      <h3>Dr. Shabnam Das Kar </h3>
                                      <p>Registration No.: 84676  (Maharashtra Medical Council)</p>
                                    </div>
                                  </div>  
                                  <div class="intake">
                                    <a href="prescription-with-medicine.html">
                                      <h6>Date</h6>
                                      <p>13 May 2021,  to 13 June 2021</p>
                                    </a>
                                  </div>
                                  <div class="Reschedule d-flex"> 
                                    <a href="#" class="btn "><i class="icon icon-x-octagon"></i></a>
                                    <a href="prescription-main.html" class="btn "><i class="icon icon-refresh"></i></a>
                                    <a href="prescription-medicine-order.html" class="btn "><i class="icon icon-shopping-bag"></i></a> 
                                  </div>
                                </div>
                                <div class="d-flex justify-content-between border-bottom align-items-center w-100 Current">
                                  <div class="Program d-flex align-items-center">
                                      <i class="icon icon-prescription"></i>
                                      <div class="Diebetes">
                                        <p>Program</p>
                                        <h3>Diebetes</h3>
                                      </div>
                                  </div>
                                  <div class="dr-history d-flex">
                                    <figure class="mb-0 mr-3"><img src="images/dr-image.svg" alt=""></figure>
                                    <div class="dr-history ">
                                      <h6>Name</h6>
                                      <h3>Dr. Shabnam Das Kar </h3>
                                      <p>Registration No.: 84676  (Maharashtra Medical Council)</p>
                                    </div>
                                  </div>  
                                  <div class="intake">
                                    <a href="prescription-with-medicine.html">
                                      <h6>Date</h6>
                                      <p>13 May 2021,  to 13 June 2021</p>
                                    </a>
                                  </div>
                                  <div class="Reschedule d-flex"> 
                                    <a href="#" class="btn "><i class="icon icon-x-octagon"></i></a>
                                    <a href="prescription-main.html" class="btn "><i class="icon icon-refresh"></i></a>
                                    <a href="prescription-medicine-order.html" class="btn "><i class="icon icon-shopping-bag"></i></a> 
                                  </div>
                                </div> -->
                                <div class="noData d-flex justify-content-center align-items-center py-5">
                                    <div class="w-100 text-center">
                                        <i class="icon icon-prescription"></i>
                                        <p>oops! You do not have an prescription yet!</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="leftOne bg-white border-radius-5 p-3">

                        <div class="mainTitle mb-2  d-flex align-items-center justify-content-between ">
                            <h4 class="mb-0">Appointments List</h4>
                            <div class="seeAll">
                                <router-link to="/book-appointment" class="themecolor d-flex align-items-center medium">See All
                                </router-link>
                            </div>
                        </div>
                        
                        <div class="table-responsive">
                            <table class="table dataTable mb-0">
                                <thead>
                                    <tr>
                                        <th><span class="msdData">Doctor Name</span></th>
                                        <th><span class="msdData">MO Name</span></th>
                                        <th><span>Start Time</span></th>
                                        <th><span>Appointment Date</span></th>
                                        <th><span class="msdData">Action </span></th>
                                    </tr>
                                </thead>
                                <tbody v-if="pageLoader">
                                    <table-loader :colspan="colspan"></table-loader>
                                </tbody>
                                <tbody v-else-if="(!pageLoader && appointmentList.totalRecords == 0)">
                                    <no-record  :type="'table'" :colspan="colspan"></no-record>
                                </tbody>
                                <tbody v-if="!pageLoader && appointmentList.totalRecords && appointmentList.totalRecords > 0 ">
                                    <tr v-for="list,index in appointmentList.records" v-if="index < 4">
                                        <td>{{list.doctorName || ''}}</td>
                                        <td>{{list.moHospital}}</td>
                                        <td>
                                            <span class="f-12 d-flex align-items-center"><feather type="clock"></feather> {{list.start_time}}</span>
                                        </td>
                                        <td>
                                            <span class="f-12 d-flex align-items-center"><feather type="calendar"></feather> {{formatDate(list.appointment_date)}}</span>
                                        </td>
                                        <td>
                                            <span class="timeInc"> 
                                                <a class="d-inline-flex bgcolor5 iconElement align-items-center" :href="list.zoom_link" target="_blank" ><feather class="mr-1" type="monitor" ></feather> On Zoom</a>
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <app-pagination :totalRecords ="appointmentList.totalRecords" :limit="pageLimit" :pageNo="page" v-if="!pageLoader && appointmentList.totalRecords && appointmentList.totalRecords > pageLimit "></app-pagination>
                        
                    </div> -->
                    <!-- <div class="leftTwo space">
                        <div class="mainTitle mb-3 d-flex align-items-center justify-content-between">
                            <h4 class="mb-0">Event Schedule List</h4>
                            <div class="rightblock d-flex align-items-center">
                                <a href="#" class="themecolor d-flex align-items-center medium">
                                    <span class="plusCircle mb-0 bg-white mr-2"><feather type="plus"></feather></span>Create Event
                                </a>
                                <a href="#" class="filterButton bg-white d-flex align-items-center mx-3"><feather type="chevron-left"></feather><span class="mx-3">01 - 07 Nov 2021</span> <feather type="chevron-right"></feather></a>
                                <div class="dropdown">
                                    <a href="#" class="filterButton bg-white d-flex align-items-center justify-content-between" type="button" data-toggle="dropdown">
                                        <span class="d-flex align-items-center"><img class="mr-1" src="../../../../static/website/images/slide.svg" alt="Icon" /> Filter </span>
                                        <feather type="chevron-down"></feather>
                                    </a>
                                   
                                </div>
                            </div>
                        </div>
                        <div class="scheduleList bg-white p-3 border-radius-5">
                            <div class="noData text-center mb-4">
                                <img src="../../../../static/website/images/No-found.svg" alt="Icon">
                                <p>No Event Yet</p>
                            </div>
                            <div class="meetOne d-flex align-items-center border-bottom pb-4 mb-4">
                                <div class="date">
                                    <span class="themecolor sm">Thu</span>
                                    <span class="lg">30</span>
                                    <span class="themecolor sm">Today</span>
                                </div>
                                <div class="rigtTable">
                                    <ul class="timeMeet d-flex align-items-center justify-content-between">
                                        <li class="timeInc bgcolor5 border-left">First meeting</li>
                                        <li class="itemsRole">With Jonathan D.</li>
                                        <li class="isoOcin"><feather type="monitor"></feather> On Zoom</li>
                                        <li class="isoOcin"><feather type="clock"></feather> 10:00 - 11:00</li>
                                        <li class="isoOcin timeInc bgcolor2"><feather type="circle"></feather> 1 hour</li>
                                    </ul>
                                    <ul class="timeMeet d-flex align-items-center justify-content-between m-0">
                                        <li class="timeInc bgcolor3 border-left">Appoitment Call</li>
                                        <li class="itemsRole">With Tajindar Pal Singh</li>
                                        <li class="isoOcin"><feather type="monitor"></feather> On Zoom</li>
                                        <li class="isoOcin"><feather type="clock"></feather> 10:00 - 11:00</li>
                                        <li class="isoOcin timeInc bgcolor3"><feather type="circle"></feather> 1 hour</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div> -->
                </div>
                <div class="col-12 col-md-3 pl-0">
                    <div class="OverallHealth  bg-white border-radius-5 p-3">
                        <div class="mainTitle mb-3">
                            <h4 class="mb-0">Overall Health Data</h4>
                        </div>
                        <div class="scheduleList ">
                            <router-link class="d-flex align-items-center justify-content-between item item-1 mb-3" to="history/sleep">
                                <div class="icon_area media align-items-center ">
                                    <div class="media-left icon_Helth">
                                        <i class="icon icon-Sleep"></i>
                                    </div>
                                    <div class="media-body">
                                        <h4>Sleep</h4>
                                        <p>02-02-2022</p>
                                    </div>
                                </div>
                                <div class="Health_details d-flex align-items-center">
                                    <h3>{{ initialData.sleep._id ? sleepTimeInHours(initialData.sleep.totalMinutesAsleep) : 0 }}</h3>
                                    <feather type="chevron-right"></feather>
                                </div>
                            </router-link>
                            <router-link class="d-flex align-items-center justify-content-between item item-2 mb-3" to="history/bp">
                                <div class="icon_area media align-items-center ">
                                    <div class="media-left icon_Helth">
                                        <i class="icon icon-blood-pressure"></i>
                                    </div>
                                    <div class="media-body">
                                        <h4>Blood Pressure</h4>
                                        <p>02-02-2022</p>
                                    </div>
                                </div>
                                <div class="Health_details d-flex align-items-center">
                                    <h3>{{ initialData.bp._id ? `${initialData.bp.high}/${initialData.bp.low}` : `N/A` }}</h3>
                                    <feather type="chevron-right"></feather>
                                </div>
                            </router-link>
                            <router-link class="d-flex align-items-center justify-content-between item item-3 mb-3" to="history/steps">
                                <div class="icon_area media align-items-center ">
                                    <div class="media-left icon_Helth">
                                        <i class="icon icon-Step"></i>
                                    </div>
                                    <div class="media-body">
                                        <h4>Steps</h4>
                                        <p>02-02-2022</p>
                                    </div>
                                </div>
                                <div class="Health_details d-flex align-items-center">
                                    <h3>{{ initialData.steps._id ? initialData.steps.steps : 0 }}</h3>
                                    <feather type="chevron-right"></feather>
                                </div>
                            </router-link>
                            <router-link class="d-flex align-items-center justify-content-between item item-4 mb-3" to="history/heart">
                                <div class="icon_area media align-items-center ">
                                    <div class="media-left icon_Helth">
                                        <i class="icon icon-healthcare-1"></i>
                                    </div>
                                    <div class="media-body">
                                        <h4>Heart Rate</h4>
                                        <p>02-02-2022</p>
                                    </div>
                                </div>
                                <div class="Health_details d-flex align-items-center">
                                    <h3>{{ initialData.heart._id ? initialData.heart.heartRate : 0 }}</h3>
                                    <feather type="chevron-right"></feather>
                                </div>
                            </router-link>
                            <router-link class="d-flex align-items-center justify-content-between item item-5 mb-3" to="history/glucose">
                                <div class="icon_area media align-items-center ">
                                    <div class="media-left icon_Helth">
                                        <i class="icon icon-sugar-blood-level"></i>
                                    </div>
                                    <div class="media-body">
                                        <h4>Glucose</h4>
                                        <p>02-02-2022</p>
                                    </div>
                                </div>
                                <div class="Health_details d-flex align-items-center">
                                    <h3>{{ initialData.glucose._id ? initialData.glucose.value : 0 }}</h3>
                                    <feather type="chevron-right"></feather>
                                </div>
                            </router-link>
                            <div class="d-flex align-items-center justify-content-between item item-6 mb-3" @click="form_popup = 'mood'">
                                <div class="icon_area media align-items-center ">
                                    <div class="media-left icon_Helth">
                                        <i class="icon icon-Mood"></i>
                                    </div>
                                    <div class="media-body">
                                        <h4>Mood</h4>
                                        <p>02-02-2022</p>
                                    </div>
                                </div>
                                <div class="Health_details d-flex align-items-center">
                                    <h3>{{ initialData.mood._id ? getMoodLabel(initialData.mood.type) : 0 }}</h3>
                                    <feather type="chevron-right"></feather>
                                </div>
                            </div>
                            <div class="d-flex align-items-center justify-content-between item item-7 mb-3" @click="form_popup = 'energy'">
                                <div class="icon_area media align-items-center ">
                                    <div class="media-left icon_Helth">
                                        <i class="icon icon-Energy"></i>
                                    </div>
                                    <div class="media-body">
                                        <h4>Energy</h4>
                                        <p>02-02-2022</p>
                                    </div>
                                </div>
                                <div class="Health_details d-flex align-items-center">
                                    <h3>{{ initialData.energy._id ? initialData.energy.info : 0 }}</h3>
                                    <feather type="chevron-right"></feather>
                                </div>
                            </div>
                            <router-link class="d-flex align-items-center justify-content-between item item-8 mb-3" to="history/weight">
                                <div class="icon_area media align-items-center ">
                                    <div class="media-left icon_Helth">
                                        <i class="icon icon-weighing-scale"></i>
                                    </div>
                                    <div class="media-body">
                                        <h4>Weight</h4>
                                        <p>02-02-2022</p>
                                    </div>
                                </div>
                                <div class="Health_details d-flex align-items-center">
                                    <h3>{{ initialData.weight._id ? getWeightLabel(initialData.weight) : 0 }}</h3>
                                    <feather type="chevron-right"></feather>
                                </div>
                            </router-link>
                        </div>
                    </div>
                    <div class="showModal">
                        <mood-form :form_type="(form_popup == 'mood')?1:(form_popup == 'energy')?2:null" v-if="form_popup == 'mood' || form_popup == 'energy'"></mood-form>
                    </div>
                    <!-- <div class="old-section">
                        <div class="mainTitle mb-3 d-flex align-items-center justify-content-between">
                            <h4 class="mb-0">Notification</h4>
                        </div>
                        <div class="notificationBlock bg-white p-3 border-radius-5" v-if="!pageLoader && notificationList.length > 0 ">
                            <div class="media mb-4" v-for="list,index in notificationList" v-if="(index < 4)">
                                <span class="timeInc bgcolor1 mr-3"><feather type="mail"></feather></span>
                                <div class="media-body">
                                    <h5 class="mb-1">{{list.message}}</h5>
                                    <p class="mb-0">{{formatDate(list.created)}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="notificationBlock bg-white p-3 border-radius-5" v-else>
                            <div class="noData text-center mb-4">
                                <img src="../../../../static/website/images/notification.png" alt="Icon">
                                <p>No Notification Yet</p>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import VueCircle from "vue2-circle-progress";
    import mood_form from "./forms/mood-form";
    import moment from 'moment';
    export default {
        name: "Dashboard",
        data() {
            return {
                fill: { color: "#25c16f" },
                pageLoader: false,
                pageLimit : 100,
                page : 1,
                colspan : 5,
                form_popup: null,
                prescription: '1'
            };
        },
        components: {
            VueCircle,
            moodForm: mood_form
        },
        methods: {
            startedIn(list){
                try{
                    let date = new Date(list.appointment_date)
                    date.setHours(list.start_time.split(':')[0])
                    date.setMinutes(list.start_time.split(':')[1])
                    return moment(date).fromNow(true)
                }catch(e){ console.log(e);return ''; }
            },
            toggleForm(){
                this.form_popup = null
            },
            getChartData() {
                let input_json = {
                    'globalParams': {},
                    'localParams': { "parameter": this }
                }
                this._runGetChartData(input_json)
            },
            listing() {
                let input_json = {
                    'globalParams': {
                        "search":"",
                        "listBy":"All",
                        "page": this.page, 
                        "perPage": this.pageLimit,
                        "filter":{}
                    },'localParams': { "parameter": this }
                }
                this._runGetAppointmentList(input_json)
            },
            notificationListFunc() {
                let input_json = {
                    'globalParams': {
                        "search":"",
                        "listBy":"",
                        "page": this.page, 
                        "perPage": this.pageLimit,
                        "filter":{}
                    },'localParams': { "parameter": this }
                }
                this._runGetNotificationList(input_json)
            }
        },
        computed: {
            userCstep: function () {
                let currentStep = this.get_user.step;
                if ("tempStep" in this.get_user && currentStep < this.get_user.tempStep) {
                    currentStep = this.get_user.tempStep;
                }
                this.userStep = currentStep;
                if (parseInt(this.userStep) == 0) {
                    if (this.$refs.completeCircle) {
                        this.$refs.completeCircle.updateProgress(1);
                    }
                } else {
                    if (this.$refs.completeCircle) {
                        this.$refs.completeCircle.updateProgress(this.userStep * 33);
                    }
                }

                // if(this.$refs.completeCircle){
                //     this.$refs.completeCircle.updateProgress(this.userStep*33 || 1);
                // }

                return this.get_user.step;
            },
        },
        created(){
            this.listing()
            let input_json = {
                'globalParams': {},
                'localParams': { "parameter": this }
            }
            this.getChartData()
            this._runGetInitialData(input_json)
            this.notificationListFunc()
            this.pageName('Dashboard')
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/website/user/dashboard.vue